import { nameVaultObject } from "@/components/vault/vault-object-util";
import { Button } from "@radix-ui/themes";
import useVaultStore, {
  useVaultStoreActions,
} from "@/stores/zustand/vault/useVaultStore";
import HUI from "@henge-inc/ui/v1_2";
import { License } from "@/types/enums";
import useVaultFilterStore from "@/stores/zustand/vault/useVaultFilterStore";

interface EditNextButtonProps {
  newName: string;
  setNewNameInputErrorMessage: (message: string) => void;
  newTagValueList: string[];
  setNewTagInputErrorMessage: (message: string) => void;
  newLicense: HUI.SelectItemInterface<License> | null;
}

export const UploadNextButton = ({
  newName,
  setNewNameInputErrorMessage,
  newTagValueList,
  setNewTagInputErrorMessage,
  newLicense,
}: EditNextButtonProps) => {
  const currentTab = useVaultStore((state) => state.currentTab);
  const { setCurrentPage, setCurrentTab, updateUploadData } =
    useVaultStoreActions();

  const currentFilter = useVaultFilterStore((state) => state.currentFilter);

  return (
    <Button
      size={"3"}
      color={"gray"}
      highContrast
      onClick={async () => {
        if (!newName) {
          setCurrentTab("metadata");
          setNewNameInputErrorMessage("제목을 입력해 주세요.");
          return;
        }

        if (newTagValueList.length === 0) {
          setCurrentTab("metadata");
          setNewTagInputErrorMessage("태그를 추가해 주세요.");
          return;
        }

        switch (currentTab) {
          case "metadata": {
            setCurrentTab("show-window");
            updateUploadData({
              name: nameVaultObject(newName),
              tags: newTagValueList,
              license: newLicense?.value,
            });
            break;
          }
          case "show-window": {
            setCurrentPage("uploader-thumbnail");
            updateUploadData({
              filter: currentFilter,
            });
            break;
          }
        }
      }}
    >
      다음
    </Button>
  );
};
